FeedsApp.Models.FeedAvailableField = FeedsApp.Models.FeedsBase.extend({

    defaults: {
        internal_field_id: null,
        internal_name: null
    }
});